import { getCurrentEnv } from '../../hooks/apiUrlResolver';

type EnvCode = 'local' | 'tst' | 'sbx' | 'qua' | 'qap' | 'prd';

const featureFlags: Record<string, EnvCode[]> = {
  thalesImplementation: ['tst'],
};

// eslint-disable-next-line import/prefer-default-export
export const isFeatureEnabled = (flag: string): boolean => {
  const env = getCurrentEnv() as EnvCode | null;
  if (!env) return false;
  const enabledEnvs = featureFlags[flag];
  const isEnabled = enabledEnvs?.includes(env) ?? false;

  return isEnabled;
};
